<script setup>
import { computed, getCurrentInstance, watch } from 'vue';
import { useAsyncState } from '@vueuse/core';

const props = defineProps({
    field: Object,
    item: Object
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const tableName = computed(() => {
    return store.state.components.items.find(
        o => o.id === props.field.modulecomponentsID || o.id === props.field.modulecomponentsId
    )?.tableName;
});

const { state: options, execute: fetchOptions } = useAsyncState(
    async () => {
        if (!tableName.value || !props.field.columnName) return [];

        const obj = await store.dispatch('request/post', {
            url: 'api/ListingController/getSelectFilterOptions',
            postData: {
                tableName: tableName.value,
                columnName: props.field.columnName
            }
        });

        if (obj.data?.length) {
            return [{ value: '--unassigned--', text: '-- Unassigned --' }, ...obj.data];
        }
        return [];
    },
    []
);

// Explicitly watch the column name. If the filter row is swapped to a different
// "Select" type field, we must re-fetch the options.
watch(() => props.field.columnName, () => fetchOptions(), { immediate: true });
</script>

<template>
    <select
        v-if="options?.length"
        v-model="item.value"
        class="form-select form-select-sm d-inline-block w-auto"
    >
        <option selected disabled value="null">Select&hellip;</option>
        <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
    <small v-else-if="options?.length === 0" class="form-text ms-2 mb-1 fst-italic small">
        No options available
    </small>
</template>